import React from 'react'

import PORelationshipOutlet from '@/components/views/ci/PO/PORelationshipsOutlet'

const PO_PORelationshipOutlet = () => {
    return <PORelationshipOutlet />
}

export default PO_PORelationshipOutlet
